export const MAX_USERNAME_LENGTH = 19;
export const DRAFT_STATUS_REQUESTED = 'DRAFT -';
